import { BannerTypeEnum } from '@api/enum/announcement.enum';
import { IAnnouncementBanner } from '@api/models/announcement.model';
import { InfoCircleIcon } from '@icon/index';
import { useMemo } from 'react';

const AnnouncementBanner = (props: Pick<IAnnouncementBanner, 'type' | 'message'>) => {
    const { type, message } = props;

    const options = useMemo(() => {
        let bgClassWithTransparency = '';
        let textClass = '';

        switch (type) {
            case BannerTypeEnum.SUCCESS:
                bgClassWithTransparency = 'bg-success-100';
                textClass = 'text-success-500';
                break;
            case BannerTypeEnum.WARNING:
                bgClassWithTransparency = 'bg-warning-100';
                textClass = 'text-warning-500';
                break;
            case BannerTypeEnum.ERROR:
                bgClassWithTransparency = 'bg-danger-100';
                textClass = 'text-danger-500';
                break;
            case BannerTypeEnum.INFO:
                bgClassWithTransparency = 'bg-grayscale-100';
                textClass = 'text-grayscale-500';
                break;
        }

        return {
            bgClassWithTransparency,
            textClass,
        };
    }, [type]);

    return (
        <div className={['flex items-center gap-3 py-2 px-6', options.bgClassWithTransparency].join(' ')}>
            <InfoCircleIcon className={[options.textClass].join(' ')} />
            <p className="text-xs font-medium text-[#101828]">{message}</p>
        </div>
    );
};

export default AnnouncementBanner;
